import * as React from "react";
import "./styles.scss";
import { VeBoxModal } from "../../../../../components/modal/VeBoxModal";
import { VeBoxCard } from "../../../../../components/card/VeBoxCard";
import { ImportEquipmentContext } from "../../providers/ImportEquipmentProvider";
import { AppTranslations } from "../../../../../components/Utils/translations/AppTranslations";
import { capitalizeFirstLetter } from "@vebox/etui-core";
import { Display } from "../../../../../components/Display";
import { FormCardFooterWithExport } from "../../components/FormCardFooterWithExport";

declare var AppTranslations: AppTranslations;

interface AdviseModalProps {
	onClose: (withRefresh: boolean) => void;
	onSubmit: () => void;
}

export const AdviseAddFoundEquipmentModal: React.FC<AdviseModalProps> = ({
	onClose,
	onSubmit,
}) => {
	const { validatedEntries, addComponentsToCensus, censusWithNewEntities } =
		React.useContext(ImportEquipmentContext);
	const [isLoading, setIsLoading] = React.useState<boolean>(false);
	const validEntriesCount = React.useMemo(
		() => validatedEntries?.listEntriesGuidValid?.length ?? 0,
		[validatedEntries, validatedEntries?.listEntriesGuidValid],
	);
	const notValidEntriesCount = React.useMemo(
		() => validatedEntries?.listEntriesCodeNotValid?.length ?? 0,
		[validatedEntries, validatedEntries?.listEntriesCodeNotValid],
	);

	const close = () => {
		onClose(false);
	};

	const submit = () => {
		setIsLoading(true);
		addComponentsToCensus(validatedEntries?.listEntriesGuidValid);
	};
	const title = AppTranslations.massiveActions.censusCooler.addToCensus;

	React.useEffect(() => {
		if (isLoading && !censusWithNewEntities?.isLoading) {
			onClose(true);
		}
	}, [censusWithNewEntities?.isLoading]);
	return (
		<VeBoxModal.Backdrop>
			<VeBoxModal>
				<VeBoxModal.Header
					titleClassName={"advise-import-modal-header-title"}
					title={
						<h2 className={"advise-import-modal-header"}>
							<span className="material-icons-outlined">info</span>
							{title}
						</h2>
					}
				/>
				<VeBoxModal.Section style={{ padding: 0 }}>
					<VeBoxCard className={"advise-import-modal-card"}>
						<p>
							{AppTranslations.massiveActions.censusCooler
								.equipmentValidAndFound + " "}
							<span className={"bold"}>
								{validEntriesCount}/{notValidEntriesCount + validEntriesCount}
							</span>
						</p>
						<br />
						<Display isVisible={notValidEntriesCount > 0}>
							<div className={"flx-row flx-space-between flx-align-center"}>
								<span>
									{AppTranslations.massiveActions.censusCooler
										.equipmentNotFoundOrInvalid + " "}
									<span className={"bold"}>
										{notValidEntriesCount}/
										{notValidEntriesCount + validEntriesCount}
									</span>
								</span>
							</div>
							<br />
						</Display>
						<Display isVisible={validEntriesCount > 0}>
							<p>
								{AppTranslations.massiveActions.censusCooler.areYouSureToAdd}
							</p>
							<p>{AppTranslations.genericWords.theOperationMayTakesMinutes}</p>
							<br />
						</Display>
					</VeBoxCard>
				</VeBoxModal.Section>
				<div className={"advise-import-modal-card-footer"}>
					<FormCardFooterWithExport
						onReset={close}
						onNext={submit}
						restButtonText={capitalizeFirstLetter(
							AppTranslations.genericWords.cancel,
						)}
						nextButtonText={capitalizeFirstLetter(
							AppTranslations.genericWords.add,
						)}
						loadable={true}
						disabled={isLoading || validEntriesCount === 0}
						disabledCancel={isLoading}
						loading={isLoading}
						canExport={notValidEntriesCount > 0}
						entriesToExport={validatedEntries?.listEntriesCodeNotValid}
					/>
				</div>
			</VeBoxModal>
		</VeBoxModal.Backdrop>
	);
};
